import ApiUrl from "./ApiUrl";

const FacilitatorUrl = ApiUrl + "facilitator/";

export const CreateFacilitatorService = (data) => {
   // crear un facilitador
   const service = `${FacilitatorUrl}register`;
   const options = {
      method: "POST",
      //mode: "no-cors",
      body: data,
      headers: {
         "Content-Type": "multipart/form-data",
      },
   };
   delete options.headers["Content-Type"];
   return fetch(service, options);
};
export const UpdateFacilitatorService = (data) => {
   // crear un facilitador
   const service = `${FacilitatorUrl}update`;
   const options = {
      method: "POST",
      //mode: "no-cors",
      body: data,
      headers: {
         "Content-Type": "multipart/form-data",
      },
   };
   delete options.headers["Content-Type"];
   return fetch(service, options);
};

export const ListFacilitatorsService = () => {
   // lista de todos los usuarios
   const service = `${FacilitatorUrl}listWeb`;
   return fetch(service);
};
export const FacilitatorProfile = (id) => {
   // lista de todos los usuarios
   const service = `${FacilitatorUrl}profile`;
   const data = {idFacilitator: id};
   return fetch(service, {
      method: "POST",
      body: JSON.stringify({...data}),
      headers: {
         "Content-Type": "application/json",
      },
   });
};

export const DeleteFacilitatorService = (dat) => {
   const service = `${FacilitatorUrl}disable`;
   const data = {token: localStorage.getItem("domecq_token")};
   return fetch(service, {
      method: "POST",
      body: JSON.stringify({...data}),
      headers: {
         "Content-Type": "application/json",
      },
   });
};
